// import { useTranslationContext } from "@providers/TranslationProvider";
import Banner from "@components/Banner";
import FeaturedItem from "@components/BrandStory/FeaturedItem";
import Paragraphs from "@components/BrandStory/Paragraphs";
import Breadcrumbs from "@components/Breadcrumbs";
import Footer from "@components/Footer";
import Header from "@components/Header";
import StayInspired from "@components/Home/StayInspired";
import { usePageContext } from "@providers/PageProvider";
import { useRouteContext } from "@providers/RouteProvider";
import helper, { brandStoryPage } from "@utils/helper";
import _ from "lodash";

const View = () => {
  const { router } = useRouteContext();
  const { pageData, hotel } = usePageContext();
  const banner = helper.formatBanner(pageData);
  const footer = helper.renderDetailsFooter(hotel);
  const featured: any = brandStoryPage.formatFeatured(pageData);
  return (
    <div className="bg-white" data-scroll-container>
      <Header />
      <Banner
        image={_.get(banner, "image")}
        scale={1.1}
        title={_.get(banner, "title", "")}
      />
      <Breadcrumbs data={router.breadcrumbs("brand-story", {})} />
      <FeaturedItem data={featured} />
      <Paragraphs />
      <StayInspired mode="light" />
      <Footer
        data={{
          name: footer.name,
          address: footer.address,
          email: footer.email,
        }}
      />
    </div>
  );
};

export default View;
